import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BlobStorageService } from '../blob-storage.service';
import { ImageDialogComponent } from './image-grid-dialog/image-dialog.component';
import { forkJoin } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-image-grid',
  templateUrl: './image-grid.component.html',
  styleUrls: ['./image-grid.component.scss']
})
export class ImageGridComponent implements OnChanges {

  @Input() urls?: string[];
  items?: { dataUri: string, rowspan: number }[];
  loading?: boolean;
  cols?: number;

  constructor(
    private _blobStorageService: BlobStorageService,
    private _sanitizer: DomSanitizer,
    public dialog: MatDialog,
  ) { }

  ngOnChanges() {
    this.items = [];
    this.loading = true;
    this.cols = 1;

    if (this.urls) {
      forkJoin(this.urls.slice(0, 4).map(url => this._blobStorageService.getReceipt(url)))
        .subscribe({
          next: responses => {
            const items = responses.filter(v => !!v).map(i => ({ dataUri: i, rowspan: 1 }));
            const numberOfItems = items.length;
            if (numberOfItems === 2) {
              this.cols = 2;
              items[0].rowspan = 2;
              items[1].rowspan = 2;
            } else if (numberOfItems === 3) {
              this.cols = 2;
              items[0].rowspan = 2;
            } else if (numberOfItems === 4) {
              this.cols = 2;
            }
            this.items = items;
          },
          error: e => console.error(e),
          complete: () => this.loading = false
        });
    }
  }

  openImageDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      data: { items: this.items, index },
      maxWidth: '100vw',
      height: '100vh',
      panelClass: 'app-dialog'
    });
  }

  bypassSecurity(url: string) {
    return this._sanitizer.bypassSecurityTrustStyle(url);
  }
}
